import { Injectable, OnInit } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as platform from 'platform';
import { environment } from '../environments/environment';



@Injectable({
  providedIn: 'root'
})
export class AppInsightsService implements OnInit {
  private appInsights: ApplicationInsights;

  constructor(private msalService: MsalService, private http: HttpClient) {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.appInsights.instrumentationKey,
        enableAutoRouteTracking: true, // Automatically track page views
        disableTelemetry: false, // Ensure telemetry is enabled
        loggingLevelConsole: 2, // Enable verbose logging
      }
    });

    this.appInsights.loadAppInsights();
    // this.trackUser();
  }
  ngOnInit() {
    // this.appInsights.trackEvent({ name: 'TestEvent', properties: { message: 'App Insights Working!' } });
    console.log('App Insights Working!')
  }


  // Track authenticated user
 async trackUser() {
    const account: AccountInfo | null = this.msalService.instance.getActiveAccount();
    if (account) {
      this.appInsights.setAuthenticatedUserContext(account.username); // Sets user email as identifier
      this.trackLoginEvent(account.username);
      const clientInfo = this.getClientInfo();
      const clientIP = await this.getClientIP();
      const locationData = await this.getClientLocation();
      
      localStorage.setItem("email", account?.username );
      localStorage.setItem("userId", account?.localAccountId );
      
      // Use locale string format for prod, ISO for dev
      // const timestamp = environment.production
      //   ? new Date().toLocaleString('en-US', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })
      //   : new Date().toISOString();
      
      // const loginTime = environment.production
      //   ? new Date().toLocaleString('en-US', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })
      //   : new Date().toISOString();
      
      const userDetails = {        
        timestamp_UTC: new Date().toISOString(),
        // timestamp_UTC: timestamp,
        name: account?.name || '',
        itemType: 'customEvent',
        customDimensions: JSON.stringify({
          email: account?.username || "Dinesh.Kumar@harpercollins.com",
          // loginTime: loginTime,
          loginTime: new Date().toISOString(),
          clientInfo: clientInfo.browser
        }),
        customMeasurements: JSON.stringify({ metric: "value" }),
        operation_Name: '/',
        operation_SyntheticSource: '',
        session_Id: account?.idTokenClaims?.sid || '',
        user_Id: account?.localAccountId || '',
        user_AuthenticatedId: account?.username || '',
        user_AccountId: account?.homeAccountId || '',
        application_Version: '',
        client_Type: 'Browser',
        client_Model: clientInfo.model,
        client_OS: clientInfo.os,
        client_IP: clientIP,
        client_City: locationData.city,
        client_StateOrProvince: locationData.region,
        client_CountryOrRegion: locationData.country,
        client_Browser: clientInfo.browser,
        cloud_RoleName: '',
        cloud_RoleInstance: '',
        appId: account?.idTokenClaims?.aud || '',
        appName: environment.appInsights.appName,
        iKey: environment.appInsights.iKey,
        sdkVersion: 'javascript:3.3.5',
        itemCount: '1',
        ResourceId: environment.appInsights.resourceId
      };
      
      const insertUrl = `${environment.appInsights.apiUrl}/insert?db_name=${environment.appInsights.dbName}`;
      
      this.http.post(insertUrl, userDetails).subscribe(response => {
        console.log('Data sent to backend:', response);
      }, error => {
        console.error('Error sending data:', error);
      });
    }
  }

  // Log login event
  trackLoginEvent(email: string) {
    this.appInsights.trackEvent({
      name: 'UserLogin',
      properties: {
        email: email,
        loginTime: new Date().toISOString().slice(0, 10), // YYYY-MM-DD
        clientInfo: navigator.userAgent
      }
    });
  }

  // Track custom events
  trackEvent(eventName: string, properties?: any) {
    this.appInsights.trackEvent({ name: eventName, properties });
  }

  // Track exceptions
  trackError(error: any) {
    this.appInsights.trackException({ exception: error });
  }

  // Track events with timing (for performance monitoring)
trackEventWithTiming(eventName: string, startTime: number, properties?: any) {
  const duration = Date.now() - startTime;

  // Create a properly formatted UTC timestamp for BigQuery (ISO 8601 format)
  const timestamp = new Date().toISOString();

  const enhancedProperties = {
    ...properties,
    duration_ms: duration,
    timestamp,  // UTC timestamp in ISO 8601 format
    status: 'pending',
  };

  // Console output for timing logs
  console.group('📊 TIMING LOG (Status: pending)');
  console.log('Event:', eventName);
  console.log('Duration:', `${duration}ms (${(duration / 1000).toFixed(2)}s)`);
  console.log('Status:', 'pending');
  console.log('Timestamp:', timestamp);
  if (properties) console.table(properties);
  console.groupEnd();

  // Send to Application Insights
  this.appInsights.trackEvent(
    {
      name: eventName,
      properties: enhancedProperties,
      measurements: { duration },
    }
  );
}


  // Start timing for an operation
  startTiming(): number {
    return Date.now();
  }

  private getClientInfo() {
    console.log(platform);
    return {
      model: platform.product || 'other',
      os: platform.os?.family || '',
      browser: platform.name || '',
    };
  }
  private async getClientIP(): Promise<string> {
    try {
      const response = await fetch('https://api64.ipify.org?format=json');
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.error('Error fetching IP:', error);
      return '';
    }
  }
  private async getClientLocation(): Promise<any> {
    try {
      const clientIp = await this.getClientIP();
      const response = await fetch(`https://ipapi.co/${clientIp}/json/`);
      return await response.json();
    } catch (error) {
      console.error('Error fetching location:', error);
      return { city: '', region: '', country: '' };
    }
  }
}
